// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunk." + {"367": "d655955c618b8c23","608": "9c6caa303d34fc8c","956": "95505584afb26874",}[chunkId] + ".css"
}